import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--black-300);
  padding: 0.8rem 0rem;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: 0;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  p {
    font-size: 1rem;
    font-family: DM Sans;
    font-weight: 500;
    padding: 0;
  }

  span {
    font-family: Inter;
    color: var(--primary);
    font-weight: 500;
    font-size: 0.78rem;
  }

  p,
  span {
    max-width: 13.75rem;
    white-space: nowrap;
    overflow: hidden;
    padding-right: 1.2rem;
    text-overflow: ellipsis;
  }

  @media (min-width: 1400px) {
    p,
    span {
      max-width: 270px;
    }
  }
`;

// common styles b etween Badge and Button components
const commonStyles = css`
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
`;

export const Badge = styled.div`
  ${commonStyles};
  width: 2.8125rem;
  height: 2.8125rem;
  background-color: var(--black-100);
  margin-right: 0.7rem;
  padding: 0.7rem;

  svg {
    path {
      stroke: var(--grey-100);
    }
  }
`;

export const Button = styled.button`
  ${commonStyles};
  width: 2.25rem;
  height: 2.25rem;
  background-color: var(--primary);
`;
